/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_5_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When a browser adds a number to a repeated download, do not assume the unnumbered file is the latest. Check the download time and reopen the file you actually intend to keep. If the file is going to another person, test that exact copy rather than a different version still open in the editor. A successful calculation in memory does not verify the contents of an older file sitting in a downloads folder.`)
};

const zh_gc_search_guides_gridcraft_online_sections_5_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器为重复下载添加编号时，不要假定没有编号的文件就是最新版。查看下载时间，并重新打开真正准备保留的副本。如果文件要交给别人，应验证交付的那个文件，而不是编辑器里仍然打开的另一个版本。内存中的计算成功，并不能证明下载文件夹里旧文件的内容正确。`)
};

/**
* | output |
* | --- |
* | "When a browser adds a number to a repeated download, do not assume the unnumbered file is the latest. Check the download time and reopen the file you actuall..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_5_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_5_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_5_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_5_paragraphs_1 as "gc.search_guides.gridcraft_online.sections.5.paragraphs.1" }